var render = function render(){var _vm=this,_c=_vm._self._c;return _c('design-2021-portfolio-shared-assignments-component',{attrs:{"education-levels-in":_vm.educationLevelsIn,"assignments-in":_vm.assignmentsIn,"organization-id-in":_vm.organizationIn.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }